import React from 'react';


import Start from '../../../img/star.png'

const MarqueeSectionS4 = () => {
    return (
        <div className="marquee-section fix">
            <div className="mycustom-marque">
                <div className="scrolling-wrap bg-style">
                    <div className="comm cmn-style-3">
                        <div className="cmn-textslide">branding</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">product design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">digital marketing</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">product design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">art direction</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">development</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">UI/UX Design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">motion graphics</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">strategy</div>
                        <div><img src={Start} alt="img" /></div>
                    </div>
                    <div className="comm cmn-style-3">
                        <div className="cmn-textslide">branding</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">product design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">digital marketing</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">product design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">art direction</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">development</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">UI/UX Design</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">motion graphics</div>
                        <div><img src={Start} alt="img" /></div>
                        <div className="cmn-textslide">strategy</div>
                        <div><img src={Start} alt="img" /></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MarqueeSectionS4;